import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './sessions.html'

/**
 * Sessions report route
 *
 * @namespace routes.ReportSessions
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.sessions.list',
  label: 'REPORT.SESSIONS.TITLE',
  url: '/sessions',
  component: 'tmrReportSessions',
  weight: 10,
  resourceType: 'Session',
  resourceList: {
    searchParameters: [
      'session.id',
      'createdBy.id',
      'confirmedBy.id',
      'place.id',
      'closingDate.from',
      'closingDate.to',
      'closed',
    ],
  },
}

/**
 * Component for {@link routes.tmrReportSessions Sessions report route}
 *
 * @type {ngComponent}
 */
export const tmrReportSessions = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
  controller: 'tmrReportSessionsController',
}

/**
 * Controller of component {@link tmrReportSessionsController}.
 *
 * @type {ngController}
 */
export class tmrReportSessionsController {
  static ngType = 'controller'

  constructor(
    $state,
    $mdDialog,
    TmrToast,
    TmrPromptModal,
    Session,
    SessionMovement
  ) {
    'ngInject'
    Object.assign(this, {
      $state,
      $mdDialog,
      TmrToast,
      TmrPromptModal,
      Session,
      SessionMovement,
    })
  }

  /** Close Session */
  askCloseSession($event, id) {
    this.TmrPromptModal($event, {
      question: 'OPERATIONS.SESSION.CLOSEQUESTION',
      yesCallback: () => this.closeSession(id),
      relativeTo: `.close-session-btn`,
    })
  }

  /** Close Session action */
  closeSession(id) {
    this.SessionMovement.count({ 'session.id': id }).then(res => {
      if (res > 0) {
        return this.Session.close({ id })
          .$promise.then(res => {
            if (res) this.closeSessionSuccess()
          })
          .catch(err => this.TmrToast.exception(err))
      } else
        return this.TmrToast.error('OPERATIONS.SESSION.EMPTY', 'messageformat')
    })
  }

  /** session closed successfully */
  closeSessionSuccess() {
    this.TmrToast.success('OPERATIONS.SESSION.SUCCESS', 'messageformat')
    this.$state.go(this.$state.current, null, { reload: true, inherit: false })
  }
}
